import { CurrencyCode } from '@/types/auction';

export const AUTH_TOKEN = 'A2O_JWT';
export const AUCTION_ID_COOKIE = 'A2O_AUCTION_GUID';
export const BETA_INTRO = 'BETA_INTRO';

// Default locale
export const DEFAULT_LOCALE = 'en-US';

// Default currency
export const DEFAULT_CURRENCY = CurrencyCode.USD;

// Unicode em dash
export const EMDASH = '\u2014';
// Unicode spaces used in currency formatting
export const NON_BREAKING_SPACE = '\u00a0';
export const NARROW_NON_BREAKING_SPACE = '\u202f';

export const TABLE_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const DEFAULT_APP_VERSION = 'unknown';

// Defaults for pagination values
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100];

export const BIDDER_STATUS_APPROVED = 'Approved';
export const BIDDER_STATUS_DECLINED = 'Declined';

/** Height (px) for sticky footer row on mapping/import page (grid row). */
export const LAYOUT_STICKY_FOOTER_ROW_HEIGHT_PX = 59;
